import { IMAGE_BUCKET_URL, IMGBUCKETURL } from "../../DataStore/ApiConstant";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import { useRef } from "react";

const FeaturedGames = ({
  login,
  openPopup,
  siteImages,
  cashier = "false",
  setSelectedGameType,
  openGeneralModal,
  goToCashier
}) => {
  const history = useHistory();
  const gameWrapperArea = useRef(null);

  const featuredGameClicked = (type) => {
    if(cashier === "true"){
      history.push("/lobby")
      gameWrapperArea.current?.scrollIntoView({ behavior: "smooth" });
      setSelectedGameType(type)
    }else{
      gameWrapperArea.current?.scrollIntoView({ behavior: "smooth" });
      setSelectedGameType(type)
    }
    // cashier === "true" ? history.push("/lobby") : setSelectedGameType(type);
  };

  return (
    <div className="container-fluid mt-lg-1 mt-1 ">
      <div className="d-flex justify-content-center">
        <div
          className="col zoom"
          onClick={() => featuredGameClicked("liveCasino")}
        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col">
            {
              Object.keys(siteImages.images).length > 0 &&
              <img
                // src={IMGBUCKETURL + siteImages?.images?.main_tile_live_casino[0]}
                src={IMGBUCKETURL + "LIVE-CASINO-test.png"}
                // src={IMGBUCKETURL + siteImages?.images?.main_tile_live_casino[0] || "default.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              ></img>
            }
            </div>
            <p className="catTitel mt-0">
              <TranslatesContent contentKey="live-casino" />
            </p>
          </div>
        </div>
            <div
              className="col zoom"
              // onClick={() => featuredGameClicked("events")}
              onClick={(e) => {
                e.preventDefault();
                login ? featuredGameClicked("BallysTournament") : openPopup("login");
              }}
            >
              <div className="row" data-aos="fade-up" data-aos-duration="3000">
                <div className="col">
                {
                  Object.keys(siteImages.images).length > 0 &&
                  <img
                    // src={IMGBUCKETURL + siteImages?.images?.main_tile_slots[0]}
                    src={IMGBUCKETURL + "TOURAMENT2-test.png"}
                    // src={IMGBUCKETURL + (siteImages?.images?.main_tile_e?.[0] || "default.png")}
                    className="img-fluid mx-auto d-block"
                    alt="..."
                  ></img>
                }
                  {/* <img
                    src={IMAGE_BUCKET_URL + "slot.png"}
                    className="img-fluid mx-auto d-block"
                    alt="..."
                  /> */}
                </div>
                <p className="catTitel mt-0">
                  <TranslatesContent contentKey="tournament-tab" />
                  {/* <TranslatesContent contentKey="events-menu" /> */}
                </p>
              </div>
            </div>
        {/* <div className="col-3 col-sm-3 zoom" onClick={() => featuredGameClicked("slots")}>
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col"> */}
            {/* {
              Object.keys(siteImages.images).length > 0 &&
              <img
                src={IMGBUCKETURL + siteImages?.images?.main_tile_slots[0]}
                className="img-fluid mx-auto d-block"
                alt="..."
              ></img>
            } */}
              {/* <img
                src={IMAGE_BUCKET_URL + "slot.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              /> */}
            {/* </div>
            <p className="catTitel mt-0">
              <TranslatesContent contentKey="slots" />
            </p>
          </div>
        </div> */}
        
        <div
          className="col zoom disabled-div"
          // className="col zoom"
          // onClick={() => featuredGameClicked("promotions")}
          onClick={() => alert("This is not reachable")}
          // onClick={(e) => {
          //   e.preventDefault();
          //   login ? featuredGameClicked("BallysTournament") : openPopup("login");
          // }}
        >
          <div className="row" data-aos="fade-up" data-aos-duration="3000">
            <div className="col">
            {
              Object.keys(siteImages.images).length > 0 &&
              <img
                // src={IMGBUCKETURL + siteImages?.images?.main_tile_promotion[0]}
                src={IMGBUCKETURL + "LOYALTY-test.png"}
                // src={IMGBUCKETURL + (siteImages?.images?.main_tile_loyalty?.[0] || "default.png")}
                className="img-fluid mx-auto d-block"
                alt="..."
              ></img>
            }
              {/* <img
                src={IMAGE_BUCKET_URL + "rummy.png"}
                className="img-fluid mx-auto d-block"
                alt="..."
              /> */}
            </div>
            <p className="catTitel mt-0">
              {/* <TranslatesContent contentKey="coupon" /> */}
              <TranslatesContent contentKey="loyalty-tab" />
            </p>
          </div>
        </div>            
              <div
                className="col zoom"
                onClick={() => featuredGameClicked("promotions")}
              >
                  <div className="row" data-aos="fade-up" data-aos-duration="3000">
                    <div className="col">
                    {
                      Object.keys(siteImages.images).length > 0 &&
                      <img
                        // src={IMGBUCKETURL + siteImages?.images?.main_tile_promotion[0]}
                        src={IMGBUCKETURL + "PROMO-test.png"}
                        className="img-fluid mx-auto d-block"
                        alt="..."
                      ></img>
                    }
                      {/* <img
                        src={IMAGE_BUCKET_URL + "rummy.png"}
                        className="img-fluid mx-auto d-block"
                        alt="..."
                      /> */}
                    </div>
                    <p className="catTitel mt-0">
                      <TranslatesContent contentKey="promotions" />
                    </p>
                  </div>
                </div>
                    <div
                      className="col zoom"
                      onClick={() => featuredGameClicked("events")}
                    >
                      <div className="row" data-aos="fade-up" data-aos-duration="3000">
                        <div className="col">
                        {
                          Object.keys(siteImages.images).length > 0 &&
                          <img
                            // src={IMGBUCKETURL + siteImages?.images?.main_tile_slots[0]}
                            src={IMGBUCKETURL + "EVENT3-test.png"}
                            // src={IMGBUCKETURL + (siteImages?.images?.main_tile_e?.[0] || "default.png")}
                            className="img-fluid mx-auto d-block"
                            alt="..."
                          ></img>
                        }
                          {/* <img
                            src={IMAGE_BUCKET_URL + "slot.png"}
                            className="img-fluid mx-auto d-block"
                            alt="..."
                          /> */}
                        </div>
                        <p className="catTitel mt-0">
                          <TranslatesContent contentKey="events-menu" />
                        </p>
                      </div>
                    </div>

        <div
          // className="col zoom disabled-div"
          // onClick={() => {login ? featuredGameClicked("loyalty") : openPopup("login")}}
          // onClick={() => featuredGameClicked("loyalty")}
          // onClick={() => alert("This is not reachable")}
          // onClick={(e) => {
          //   e.preventDefault();
          //   login ? openGeneralModal("sportsModal") : openPopup("login");
          //   ;
          // }}
          // onClick={() => alert("This is not reachable")}
        >
            {/* <div className="row" data-aos="fade-up" data-aos-duration="3000"> */}
              {/* <div className="col">
              {
                Object.keys(siteImages.images).length > 0 &&
                <img
                  src={IMGBUCKETURL + (Array.isArray(siteImages?.images?.main_tile_ipl) ? siteImages.images.main_tile_ipl[0] : "default.png")}
                  className="img-fluid mx-auto d-block"
                  alt="..."
                ></img>
              }
              </div>
              <p className="catTitel mt-0">
                SPORTS
              </p>
            </div> */}
        </div>
      </div>


      <div style={{scrollmargin: "400px"}} ref={gameWrapperArea}></div>
    </div>

    
  );
};


const setStatetoProps = (state) => {
  return {
    LanguageContent: state.SiteLanguages,
    siteImages : state.siteImages
  };
};

export default connect(setStatetoProps)(FeaturedGames);

// export default FeaturedGames;
